/**
 * Utility functions for handling image URLs in the application
 */

const BACKEND_BASE_URL = process.env.REACT_APP_API_BASE_URL?.replace('/api', '') || 'http://localhost:8080';

/**
 * Converts a relative image path to a full URL
 * @param relativePath - The relative path returned by the backend (e.g., '/uploads/avatars/file.jpg')
 * @returns Full URL or undefined if no path provided
 */
export const getImageUrl = (relativePath: string | undefined): string | undefined => {
  if (!relativePath) return undefined;
  if (relativePath.startsWith('http')) return relativePath; // Already a full URL
  return `${BACKEND_BASE_URL}${relativePath.startsWith('/') ? '' : '/'}${relativePath}`;
};

/**
 * Gets the backend base URL for manual URL construction
 */
export const getBackendBaseUrl = (): string => {
  return BACKEND_BASE_URL;
};
